export var NgxMsgPosition = (function () {
    function NgxMsgPosition() {
    }
    NgxMsgPosition.TopRight = 1;
    NgxMsgPosition.BottomRight = 2;
    NgxMsgPosition.TopLeft = 3;
    NgxMsgPosition.BottomLeft = 4;
    NgxMsgPosition.TopFull = 5;
    NgxMsgPosition.BottomFull = 6;
    return NgxMsgPosition;
}());
export var NgxMsgLevel = (function () {
    function NgxMsgLevel() {
    }
    NgxMsgLevel.Success = 1;
    NgxMsgLevel.Info = 2;
    NgxMsgLevel.Warning = 3;
    NgxMsgLevel.Error = 4;
    return NgxMsgLevel;
}());
//# sourceMappingURL=ngx-msg.constants.js.map